import React from 'react';
import { Box, Flex } from 'rebass';
import { Switch, Route } from 'react-router-dom';

import { Header } from './common/Header';
import AccountManagement from './account/AccountManagement';
import { Catalogs } from './catalogs/Catalogs';
import CatalogTypes from './catalogTypes/CatalogTypes';
import ContractGroupRoutes from './productContracts/ContractGroupRoutes';
import Departments from './departments/Departments';
import Notifications from '../notifications/Notifications';
import OrderIssues from './orders/OrderIssues';
import ProductsRoutes from './products/ProductsRoutes';

const SystemManagement = () => {
  return (
    <Flex flexDirection='column' height='100%' width='100%' style={{ overflow: 'auto' }}>
      <Header />
      <Box height='100%' width='100%'>
        <Switch>
          <Route path='/accounts'>
            <AccountManagement />
          </Route>
          <Route path='/catalogs'>
            <Catalogs />
          </Route>
          <Route path='/catalogTypes'>
            <CatalogTypes />
          </Route>
          <Route path='/departments'>
            <Departments />
          </Route>
          <Route path='/notifications'>
            <Notifications />
          </Route>
          <Route path='/orderIssues'>
            <OrderIssues />
          </Route>
          <Route path='/productContractGroups'>
            <ContractGroupRoutes />
          </Route>
          <Route path='/products'>
            <ProductsRoutes />
          </Route>
        </Switch>
      </Box>
    </Flex>
  );
};
export default SystemManagement;
